import { SemanticWebIcon } from './SemanticWebIcon';

/**
 * author: Contributors
 * id 43AB1D06-4033-4F02-8147-B692F4534174
 * name semantic-web
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/semantic-web.svg
 * tags
 * - Developer / Languages 
 * - Brand / Logo 
 */
export const W3cIcon = SemanticWebIcon;
export default W3cIcon